import * as STD                   from '@emersya/mpa-std-lib';
import CM                         from '@emersya/mpa-components-manager-lib';

export interface ISectionComponentConfiguration extends CM.DOMComponent.IConfiguration {
};

export class SectionComponent<
	TComponent extends SectionComponent<TComponent, TConfiguration> = SectionComponent<any, any>,
	TConfiguration extends ISectionComponentConfiguration = any
> extends CM.DOMComponent<
	HTMLDivElement,
	SectionComponent<TComponent, TConfiguration>,
	TConfiguration
>
{
	static count = 0;
	component_DOM : HTMLDivElement;

	protected override component_childIsVisible(child : CM.DOMComponent<any, any, any>) {
		if (!super.component_childIsVisible(child)) {
			return (false);
		}
		if (this.component_parent instanceof MenuPanelComponent) {
			const menuPanel = this.component_parent as MenuPanelComponent;
			if (menuPanel.currentSection === this) {
				return true;
			} else if (!menuPanel.currentSection) {
				return (this.component_innerChilds[ 0 ] === child);
			} else {
				return false;
			}
		} else if (this.component_parent instanceof MenuAccordionComponent) {
			const menuAccordion = this.component_parent as MenuAccordionComponent;
			if (menuAccordion.currentSection === this) {
				return true;
			} else {
				return (this.component_innerChilds[ 0 ] === child);
			}
		}
		return true;
	};

	override component_childIsActive(child : CM.Component<any, any>) {
		if (this.component_parent instanceof MenuPanelComponent) {
			const menuPanel = this.component_parent as MenuPanelComponent;
			if (menuPanel.currentSection === this) {
				return (super.component_childIsActive(child));
			} else if (!menuPanel.currentSection) {
				return (
					(this.component_innerChilds[ 0 ] === child) &&
					super.component_childIsActive(child)
				);
			} else {
				return false;
			}
		} else if (this.component_parent instanceof MenuAccordionComponent) {
			const menuAccordion = this.component_parent as MenuAccordionComponent;
			if (menuAccordion.currentSection === this) {
				return (super.component_childIsActive(child));
			} else {
				return ((this.component_innerChilds[ 0 ] === child) && super.component_childIsActive(child));
			}
		}
		return (super.component_childIsActive(child));
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : TConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
	};
};
export namespace NS {
	export const Component = SectionComponent;
	export type Component = SectionComponent<SectionComponent<any, ISectionComponentConfiguration>, ISectionComponentConfiguration>;
	export type Configuration = ISectionComponentConfiguration;
}
;
import { MenuPanelComponent }     from '../menus/MenuPanel/MenuPanel';
import { MenuAccordionComponent } from '../menus/MenuAccordion/MenuAccordion';

CM.declare({
	id :   'section',
	type : SectionComponent
});
